import Backbone from 'backbone';
import Cache from 'root/cache';

var Statistics = Backbone.Model.extend({
    syncProjectCount: function(project_id) {
        this.is_loading = true;

        Cache.app.request({
            action: 'statistics/projectCount',
            data: {
                project_id: project_id
            },
            success: (response) => {
                this.set('project_count', {...this.get('project_count'), ...response});
                Cache.project.sort();
            },
            complete: () => {
                this.is_loading = false
            }
        });
    }
});

export default Statistics;